import type * as React from "react";
import { cn } from "@/lib/utils";

/**
 * The nymbl.app section label ("WHY CUSTOM", "WHAT WE BUILD"): DM Mono,
 * uppercase, tracked out, in brand violet. Use it above a heading to say which
 * group a screen or section belongs to — never as body text.
 */
export function Eyebrow({ className, ...props }: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="eyebrow"
      className={cn(
        "font-mono text-xs font-medium tracking-[0.08em] text-primary uppercase",
        className,
      )}
      {...props}
    />
  );
}
